import { render, staticRenderFns } from "./CustomImageUpload.vue?vue&type=template&id=dee057e6&"
import script from "./CustomImageUpload.vue?vue&type=script&lang=js&"
export * from "./CustomImageUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports